// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import sessionStatusEntity from './entities/session-status.json';
import sessionStatusMenu from '../pages/session-status/menu.json';
import sessionStatusFullForm from '../pages/session-status/forms/full.json';
import sessionStatusContextForm from '../pages/session-status/forms/context.json';
import sessionStatusMiniForm from '../pages/session-status/forms/mini.json';
import sessionStatusLookupForm from '../pages/session-status/forms/lookup.json';
import sessionStatusTableView from '../pages/session-status/views/table.json';
import sessionStatusDashboardView from '../pages/session-status/views/dashboard.json';

/** Тип запису «Статус засідання» зі сторінками пакета: меню, форми та подання з pages/session-status/. */
export const sessionStatusDefinition: IRecordTypeDefinition = {
  ...sessionStatusEntity,
  views: assembleViewSet({
      table: sessionStatusTableView,
      dashboard: sessionStatusDashboardView,
  }),
  form: sessionStatusFullForm,
  forms: { full: sessionStatusFullForm, context: sessionStatusContextForm, mini: sessionStatusMiniForm, lookup: sessionStatusLookupForm },
  menu: sessionStatusMenu,
} as IRecordTypeDefinition;
